window.addEventListener('DOMContentLoaded', function(e) {
    let sliders = document.querySelectorAll('.slider-element-alt');
    for (let i = 0 ; i < sliders.length ; i++) {
        let prev = sliders[i].querySelector('button.prev');
        let next = sliders[i].querySelector('button.next');

        let track = sliders[i].querySelector('.slider-track');

        // Do some calculations
        let item_width = sliders[i].querySelector('.slider-track > *').getBoundingClientRect().width + 15;
        let num_in_view = Math.floor(track.getBoundingClientRect().width / item_width);
        let prev_end_position = sliders[i].getAttribute('data-num-items') - num_in_view - 1;
        let end_position = sliders[i].getAttribute('data-num-items') - num_in_view - 1;
        let max_translate = (end_position * item_width);

        console.log(end_position, num_in_view)

        sliders[i].setAttribute('style', `--tooltip-translate:${item_width}px; --tooltip-max-translate:${max_translate}px;`);

        prev.addEventListener('click', function(e) {
            let curr_pos = sliders[i].getAttribute('data-position');
            let target = parseInt(curr_pos) - 1;
            if (target >= 0) {
                sliders[i].setAttribute('data-position', target);
            }
            if (target == 0) {
                prev.classList.add('hidden');
            }
            next.classList.remove('hidden');
        })

        next.addEventListener('click', function(e) {
            let curr_pos = sliders[i].getAttribute('data-position');
            let target = parseInt(curr_pos) + 1;
            if (target <= end_position) {
                sliders[i].setAttribute('data-position', target);
            }
            if (target < end_position) {
                next.classList.add('hidden');
            }
            prev.classList.remove('hidden');
        })

        window.addEventListener('resize', function(e) {
            // Update calculations
            item_width = sliders[i].querySelector('.slider-track > *').getBoundingClientRect().width + 15;
            num_in_view = Math.floor(track.getBoundingClientRect().width / item_width);
            end_position = sliders[i].getAttribute('data-num-items') - num_in_view - 1;
            max_translate = (end_position * item_width);

            if (prev_end_position != end_position) {
                if (sliders[i].getAttribute('data-position') == prev_end_position) {
                    sliders[i].setAttribute('data-position', end_position);
                }
                prev_end_position = end_position;
            }

            sliders[i].setAttribute('style', `--tooltip-translate:${item_width}px; --tooltip-max-translate:${max_translate}px;`);
        })

        let anchors = sliders[i].querySelectorAll('a');
        if (anchors) {
            for (let j = 0 ; j < anchors.length ; j++) {
                anchors[j].addEventListener('click', function(e) {
                    if (!preventFlag) {
                        preventFlag = true; // reset flag
                        return;
                    }
                    e.preventDefault(); 
                })
            }
        }
    }
})